import React from 'react';
import Spinner from '../spinner';
import './styles.scss';

const MockRetailConfigurator = () => {
    // Since server.webpack.config.js is having errors on using ModuleFederationPlugin during SSR, this MockRetailConfigurator is loaded
    return (
        <Spinner extraClassName='mock-retail-configurator__spinner' />
    )
}
export default MockRetailConfigurator;
